function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var BasePlugin = require('@uppy/core/lib/BasePlugin');

var _require = require('@uppy/companion-client'),
    Socket = _require.Socket,
    Provider = _require.Provider,
    RequestClient = _require.RequestClient;

var EventTracker = require('@uppy/utils/lib/EventTracker');

var emitSocketProgress = require('@uppy/utils/lib/emitSocketProgress');

var getSocketHost = require('@uppy/utils/lib/getSocketHost');

var _require2 = require('@uppy/utils/lib/RateLimitedQueue'),
    RateLimitedQueue = _require2.RateLimitedQueue;

var MultipartUploader = require('./MultipartUploader');

function assertServerError(res) {
  if (res && res.error) {
    var error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }

  return res;
}

module.exports = (_temp = _class = /*#__PURE__*/function (_BasePlugin) {
  _inherits(AwsS3Multipart, _BasePlugin);

  var _super = _createSuper(AwsS3Multipart);

  function AwsS3Multipart(uppy, opts) {
    var _this;

    _classCallCheck(this, AwsS3Multipart);

    _this = _super.call(this, uppy, opts);
    _this.type = 'uploader';
    _this.id = _this.opts.id || 'AwsS3Multipart';
    _this.title = 'AWS S3 Multipart';
    _this.client = new RequestClient(uppy, opts);
    var defaultOptions = {
      timeout: 30 * 1000,
      limit: 0,
      retryDelays: [0, 1000, 3000, 5000],
      createMultipartUpload: _this.createMultipartUpload.bind(_assertThisInitialized(_this)),
      listParts: _this.listParts.bind(_assertThisInitialized(_this)),
      prepareUploadParts: _this.prepareUploadParts.bind(_assertThisInitialized(_this)),
      abortMultipartUpload: _this.abortMultipartUpload.bind(_assertThisInitialized(_this)),
      completeMultipartUpload: _this.completeMultipartUpload.bind(_assertThisInitialized(_this))
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);
    _this.upload = _this.upload.bind(_assertThisInitialized(_this));
    _this.requests = new RateLimitedQueue(_this.opts.limit);
    _this.uploaders = Object.create(null);
    _this.uploaderEvents = Object.create(null);
    _this.uploaderSockets = Object.create(null);
    return _this;
  }
  /**
   * Clean up all references for a file's upload: the MultipartUploader instance,
   * any events related to the file, and the Companion WebSocket connection.
   *
   * Set `opts.abort` to tell S3 that the multipart upload is cancelled and must be removed.
   * This should be done when the user cancels the upload, not when the upload is completed or errored.
   */


  _createClass(AwsS3Multipart, [{
    key: "resetUploaderReferences",
    value: function resetUploaderReferences(fileID, opts) {
      if (opts === void 0) {
        opts = {};
      }

      if (this.uploaders[fileID]) {
        this.uploaders[fileID].abort({
          really: opts.abort || false
        });
        this.uploaders[fileID] = null;
      }

      if (this.uploaderEvents[fileID]) {
        this.uploaderEvents[fileID].remove();
        this.uploaderEvents[fileID] = null;
      }

      if (this.uploaderSockets[fileID]) {
        this.uploaderSockets[fileID].close();
        this.uploaderSockets[fileID] = null;
      }
    }
  }, {
    key: "assertHost",
    value: function assertHost(method) {
      if (!this.opts.companionUrl) {
        throw new Error("Expected a `companionUrl` option containing a Companion address, or if you are not using Companion, a custom `".concat(method, "` implementation."));
      }
    }
  }, {
    key: "createMultipartUpload",
    value: function createMultipartUpload(file) {
      this.assertHost('createMultipartUpload');
      var metadata = {};
      Object.keys(file.meta).forEach(function (key) {
        if (file.meta[key] != null) {
          metadata[key] = file.meta[key].toString();
        }
      });
      return this.client.post('s3/multipart', {
        filename: file.name,
        type: file.type,
        metadata: metadata
      }).then(assertServerError);
    }
  }, {
    key: "listParts",
    value: function listParts(file, _ref) {
      var key = _ref.key,
          uploadId = _ref.uploadId;
      this.assertHost('listParts');
      var filename = encodeURIComponent(key);
      return this.client.get("s3/multipart/".concat(uploadId, "?key=").concat(filename)).then(assertServerError);
    }
  }, {
    key: "prepareUploadParts",
    value: function prepareUploadParts(file, _ref2) {
      var key = _ref2.key,
          uploadId = _ref2.uploadId,
          partNumbers = _ref2.partNumbers;
      this.assertHost('prepareUploadParts');
      var filename = encodeURIComponent(key);
      return this.client.get("s3/multipart/".concat(uploadId, "/batch?key=").concat(filename, "&partNumbers=").concat(partNumbers.join(','))).then(assertServerError);
    }
  }, {
    key: "completeMultipartUpload",
    value: function completeMultipartUpload(file, _ref3) {
      var key = _ref3.key,
          uploadId = _ref3.uploadId,
          parts = _ref3.parts;
      this.assertHost('completeMultipartUpload');
      var filename = encodeURIComponent(key);
      var uploadIdEnc = encodeURIComponent(uploadId);
      return this.client.post("s3/multipart/".concat(uploadIdEnc, "/complete?key=").concat(filename), {
        parts: parts
      }).then(assertServerError);
    }
  }, {
    key: "abortMultipartUpload",
    value: function abortMultipartUpload(file, _ref4) {
      var key = _ref4.key,
          uploadId = _ref4.uploadId;
      this.assertHost('abortMultipartUpload');
      var filename = encodeURIComponent(key);
      var uploadIdEnc = encodeURIComponent(uploadId);
      return this.client.delete("s3/multipart/".concat(uploadIdEnc, "?key=").concat(filename)).then(assertServerError);
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var onStart = function onStart(data) {
          var cFile = _this2.uppy.getFile(file.id);

          _this2.uppy.setFileState(file.id, {
            s3Multipart: _objectSpread(_objectSpread({}, cFile.s3Multipart), {}, {
              key: data.key,
              uploadId: data.uploadId
            })
          });
        };

        var onProgress = function onProgress(bytesUploaded, bytesTotal) {
          _this2.uppy.emit('upload-progress', file, {
            uploader: _this2,
            bytesUploaded: bytesUploaded,
            bytesTotal: bytesTotal
          });
        };

        var onError = function onError(err) {
          _this2.uppy.log(err);

          _this2.uppy.emit('upload-error', file, err);

          queuedRequest.done();

          _this2.resetUploaderReferences(file.id);

          reject(err);
        };

        var onSuccess = function onSuccess(result) {
          var uploadResp = {
            body: _objectSpread({}, result),
            uploadURL: result.location
          };
          queuedRequest.done();

          _this2.resetUploaderReferences(file.id);

          var cFile = _this2.uppy.getFile(file.id);

          _this2.uppy.emit('upload-success', cFile || file, uploadResp);

          if (result.location) {
            _this2.uppy.log("Download ".concat(upload.file.name, " from ").concat(result.location));
          }

          resolve(upload);
        };

        var onPartComplete = function onPartComplete(part) {
          var cFile = _this2.uppy.getFile(file.id);

          if (!cFile) {
            return;
          }

          _this2.uppy.emit('s3-multipart:part-uploaded', cFile, part);
        };

        var upload = new MultipartUploader(file.data, _objectSpread({
          // .bind to pass the file object to each handler.
          createMultipartUpload: _this2.opts.createMultipartUpload.bind(_this2, file),
          listParts: _this2.opts.listParts.bind(_this2, file),
          prepareUploadParts: _this2.opts.prepareUploadParts.bind(_this2, file),
          completeMultipartUpload: _this2.opts.completeMultipartUpload.bind(_this2, file),
          abortMultipartUpload: _this2.opts.abortMultipartUpload.bind(_this2, file),
          getChunkSize: _this2.opts.getChunkSize ? _this2.opts.getChunkSize.bind(_this2) : null,
          onStart: onStart,
          onProgress: onProgress,
          onError: onError,
          onSuccess: onSuccess,
          onPartComplete: onPartComplete,
          limit: _this2.opts.limit || 5,
          retryDelays: _this2.opts.retryDelays || []
        }, file.s3Multipart));
        _this2.uploaders[file.id] = upload;
        _this2.uploaderEvents[file.id] = new EventTracker(_this2.uppy);

        var queuedRequest = _this2.requests.run(function () {
          if (!file.isPaused) {
            upload.start();
          } // Don't do anything here, the caller will take care of cancelling the upload itself
          // using resetUploaderReferences(). This is because resetUploaderReferences() has to be
          // called when this request is still in the queue, and has not been started yet, too. At
          // that point this cancellation function is not going to be called.


          return function () {};
        });

        _this2.onFileRemove(file.id, function (removed) {
          queuedRequest.abort();

          _this2.resetUploaderReferences(file.id, {
            abort: true
          });

          resolve("upload ".concat(removed.id, " was removed"));
        });

        _this2.onCancelAll(file.id, function () {
          queuedRequest.abort();

          _this2.resetUploaderReferences(file.id, {
            abort: true
          });

          resolve("upload ".concat(file.id, " was canceled"));
        });

        _this2.onFilePause(file.id, function (isPaused) {
          if (isPaused) {
            // Remove this file from the queue so another file can start in its place.
            queuedRequest.abort();
            upload.pause();
          } else {
            // Resuming an upload should be queued, else you could pause and then
            // resume a queued upload to make it skip the queue.
            queuedRequest.abort();
            queuedRequest = _this2.requests.run(function () {
              upload.start();
              return function () {};
            });
          }
        });

        _this2.onPauseAll(file.id, function () {
          queuedRequest.abort();
          upload.pause();
        });

        _this2.onResumeAll(file.id, function () {
          queuedRequest.abort();

          if (file.error) {
            upload.abort();
          }

          queuedRequest = _this2.requests.run(function () {
            upload.start();
            return function () {};
          });
        }); // Don't double-emit upload-started for Golden Retriever-restored files that were already started


        if (!file.progress.uploadStarted || !file.isRestored) {
          _this2.uppy.emit('upload-started', file);
        }
      });
    }
  }, {
    key: "uploadRemote",
    value: function uploadRemote(file) {
      var _this3 = this;

      this.resetUploaderReferences(file.id); // Don't double-emit upload-started for Golden Retriever-restored files that were already started

      if (!file.progress.uploadStarted || !file.isRestored) {
        this.uppy.emit('upload-started', file);
      }

      if (file.serverToken) {
        return this.connectToServerSocket(file);
      }

      return new Promise(function (resolve, reject) {
        var Client = file.remote.providerOptions.provider ? Provider : RequestClient;
        var client = new Client(_this3.uppy, file.remote.providerOptions);
        client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
          protocol: 's3-multipart',
          size: file.data.size,
          metadata: file.meta
        })).then(function (res) {
          _this3.uppy.setFileState(file.id, {
            serverToken: res.token
          });

          file = _this3.uppy.getFile(file.id);
          return file;
        }).then(function (file) {
          return _this3.connectToServerSocket(file);
        }).then(function () {
          resolve();
        }).catch(function (err) {
          _this3.uppy.emit('upload-error', file, err);

          reject(err);
        });
      });
    }
  }, {
    key: "connectToServerSocket",
    value: function connectToServerSocket(file) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var token = file.serverToken;
        var host = getSocketHost(file.remote.companionUrl);
        var socket = new Socket({
          target: "".concat(host, "/api/").concat(token),
          autoOpen: false
        });
        _this4.uploaderSockets[file.id] = socket;
        _this4.uploaderEvents[file.id] = new EventTracker(_this4.uppy);

        _this4.onFileRemove(file.id, function () {
          queuedRequest.abort();
          socket.send('cancel', {});

          _this4.resetUploaderReferences(file.id, {
            abort: true
          });

          resolve("upload ".concat(file.id, " was removed"));
        });

        _this4.onFilePause(file.id, function (isPaused) {
          if (isPaused) {
            // Remove this file from the queue so another file can start in its place.
            queuedRequest.abort();
            socket.send('pause', {});
          } else {
            // Resuming an upload should be queued, else you could pause and then
            // resume a queued upload to make it skip the queue.
            queuedRequest.abort();
            queuedRequest = _this4.requests.run(function () {
              socket.send('resume', {});
              return function () {};
            });
          }
        });

        _this4.onPauseAll(file.id, function () {
          queuedRequest.abort();
          socket.send('pause', {});
        });

        _this4.onCancelAll(file.id, function () {
          queuedRequest.abort();
          socket.send('cancel', {});

          _this4.resetUploaderReferences(file.id);

          resolve("upload ".concat(file.id, " was canceled"));
        });

        _this4.onResumeAll(file.id, function () {
          queuedRequest.abort();

          if (file.error) {
            socket.send('pause', {});
          }

          queuedRequest = _this4.requests.run(function () {
            socket.send('resume', {});
          });
        });

        _this4.onRetry(file.id, function () {
          // Only do the retry if the upload is actually in progress;
          // else we could try to send these messages when the upload is still queued.
          // We may need a better check for this since the socket may also be closed
          // for other reasons, like network failures.
          if (socket.isOpen) {
            socket.send('pause', {});
            socket.send('resume', {});
          }
        });

        _this4.onRetryAll(file.id, function () {
          if (socket.isOpen) {
            socket.send('pause', {});
            socket.send('resume', {});
          }
        });

        socket.on('progress', function (progressData) {
          return emitSocketProgress(_this4, progressData, file);
        });
        socket.on('error', function (errData) {
          _this4.uppy.emit('upload-error', file, new Error(errData.error));

          _this4.resetUploaderReferences(file.id);

          queuedRequest.done();
          reject(new Error(errData.error));
        });
        socket.on('success', function (data) {
          var uploadResp = {
            uploadURL: data.url
          };

          _this4.uppy.emit('upload-success', file, uploadResp);

          _this4.resetUploaderReferences(file.id);

          queuedRequest.done();
          resolve();
        });

        var queuedRequest = _this4.requests.run(function () {
          socket.open();

          if (file.isPaused) {
            socket.send('pause', {});
          }

          return function () {};
        });
      });
    }
  }, {
    key: "upload",
    value: function upload(fileIDs) {
      var _this5 = this;

      if (fileIDs.length === 0) return Promise.resolve();
      var promises = fileIDs.map(function (id) {
        var file = _this5.uppy.getFile(id);

        if (file.isRemote) {
          return _this5.uploadRemote(file);
        }

        return _this5.uploadFile(file);
      });
      return Promise.all(promises);
    }
  }, {
    key: "onFileRemove",
    value: function onFileRemove(fileID, cb) {
      this.uploaderEvents[fileID].on('file-removed', function (file) {
        if (fileID === file.id) cb(file.id);
      });
    }
  }, {
    key: "onFilePause",
    value: function onFilePause(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-pause', function (targetFileID, isPaused) {
        if (fileID === targetFileID) {
          // const isPaused = this.uppy.pauseResume(fileID)
          cb(isPaused);
        }
      });
    }
  }, {
    key: "onRetry",
    value: function onRetry(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-retry', function (targetFileID) {
        if (fileID === targetFileID) {
          cb();
        }
      });
    }
  }, {
    key: "onRetryAll",
    value: function onRetryAll(fileID, cb) {
      var _this6 = this;

      this.uploaderEvents[fileID].on('retry-all', function () {
        if (!_this6.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onPauseAll",
    value: function onPauseAll(fileID, cb) {
      var _this7 = this;

      this.uploaderEvents[fileID].on('pause-all', function () {
        if (!_this7.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onCancelAll",
    value: function onCancelAll(fileID, cb) {
      var _this8 = this;

      this.uploaderEvents[fileID].on('cancel-all', function () {
        if (!_this8.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onResumeAll",
    value: function onResumeAll(fileID, cb) {
      var _this9 = this;

      this.uploaderEvents[fileID].on('resume-all', function () {
        if (!_this9.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "install",
    value: function install() {
      var _this$uppy$getState = this.uppy.getState(),
          capabilities = _this$uppy$getState.capabilities;

      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          resumableUploads: true
        })
      });
      this.uppy.addUploader(this.upload);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      var _this$uppy$getState2 = this.uppy.getState(),
          capabilities = _this$uppy$getState2.capabilities;

      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          resumableUploads: false
        })
      });
      this.uppy.removeUploader(this.upload);
    }
  }]);

  return AwsS3Multipart;
}(BasePlugin), _class.VERSION = "2.2.1", _temp);